<script setup lang="ts">
  import type { AssignmentSet } from '@/types/Task'
  import { useImage } from '@/composables/useImage'

  import AssignmentListItem from '@/components/task/AssignmentListItem.vue'
  import ImageWithCaption from '@/components/common/ImageWithCaption.vue'
  import Typography from '@/components/common/Typography.vue'

  const props = defineProps<{
    assignmentSet: AssignmentSet
    index: number
  }>()

  const { src, altText, caption, copyright } = useImage({ imageId: props.assignmentSet.image?.destinationContentId ?? '' })
</script>

<template>
  <div class="assignment-set">
    <div class="title">
      <Typography component="h2" variant="h3">
        {{ assignmentSet.title }}
      </Typography>
    </div>
    <div class="content">
      <div class="left">
        <ul>
          <AssignmentListItem
            v-for="(contentId, assignmentIndex) in assignmentSet.assignmentContentIds"
            :key="contentId"
            :content-id="contentId"
            :index="index + assignmentIndex"
          />
        </ul>
      </div>
      <div class="right">
        <ImageWithCaption
          v-if="src"
          :src="src"
          :alt-text="altText"
          :caption="caption"
          :copyright="copyright"
          aspect-ratio="3/2"
          object-fit="cover"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .assignment-set {
    background: var(--color-violet-10);
    height: auto;
    width: 100%;
    padding: 64px 40px;

    @include vgs-media-mobile-and-tablet {
      padding: 20px;
    }
  }

  .content {
    display: flex;
    gap: 24px;

    @include vgs-media-mobile-and-tablet {
      display: block;
    }
  }

  .left {
    flex: 2;

    @include vgs-media-mobile-and-tablet {
      width: 100%;
    }

    ul {
      margin: 0;
      padding: 0;
      cursor: pointer;
    }
  }

  .right {
    flex: 1;

    @include vgs-media-mobile-and-tablet {
      width: 100%;
      margin-top: 16px;
    }

    img {
      width: 100%;
    }
  }

  .router-link {
    text-decoration: none;
  }
</style>
